import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FileSignature, FileText, Plus, Search, MoreHorizontal, Download, Copy, Edit2 } from 'lucide-react';
export function ContractsPage() {
  const [activeTab, setActiveTab] = useState('Templates');
  const tabs = ['Templates', 'Generated Docs', 'Signed Docs', 'Clause Library'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-2602">
      {/* Header */}
      <div className="flex justify-between items-center mb-6" data-id="element-2603">
        <h2 className="text-2xl font-bold" data-id="element-2604">Contracts & Documents</h2>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-2605">
          <Plus className="w-4 h-4" data-id="element-2606" />
          New Template
        </button>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-2607">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-2608">
            {tab}
          </button>)}
      </div>

      {/* Search */}
      <div className="mb-6" data-id="element-2609">
        <div className="relative max-w-md" data-id="element-2610">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-2611" />
          <input type="text" placeholder="Search documents..." className="w-full pl-9 pr-4 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-2612" />
        </div>
      </div>

      {/* Tab Content */}
      <div className="pb-12" data-id="element-2613">
        {activeTab === 'Templates' && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-2614">
            {[{
          name: 'Standard Performance Contract',
          type: 'Contract',
          updated: '2 weeks ago'
        }, {
          name: 'Festival Rider',
          type: 'Rider',
          updated: '1 month ago'
        }, {
          name: 'Standard Tech Rider',
          type: 'Rider',
          updated: '2 months ago'
        }, {
          name: 'W-9 Form',
          type: 'Tax',
          updated: '6 months ago'
        }, {
          name: 'Private Event Contract',
          type: 'Contract',
          updated: '3 months ago'
        }].map((template, i) => <div key={i} className="bg-surface border border-border rounded-xl p-5 hover:border-primary/50 transition-colors group flex flex-col" data-id="element-2615">
                <div className="flex justify-between items-start mb-4" data-id="element-2616">
                  <div className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center" data-id="element-2617">
                    <FileSignature className="w-5 h-5 text-primary" data-id="element-2618" />
                  </div>
                  <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-2619">
                    <button className="p-1.5 text-textMuted hover:text-textMain hover:bg-background rounded" data-id="element-2620">
                      <Copy className="w-4 h-4" data-id="element-2621" />
                    </button>
                    <button className="p-1.5 text-textMuted hover:text-textMain hover:bg-background rounded" data-id="element-2622">
                      <Edit2 className="w-4 h-4" data-id="element-2623" />
                    </button>
                  </div>
                </div>
                <h3 className="font-medium text-sm mb-1" data-id="element-2624">{template.name}</h3>
                <div className="flex items-center justify-between mt-auto pt-4 text-xs text-textMuted" data-id="element-2625">
                  <span data-id="element-2626">{template.type}</span>
                  <span data-id="element-2627">Updated {template.updated}</span>
                </div>
              </div>)}
          </div>}

        {activeTab === 'Generated Docs' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-2628">
            <table className="w-full text-sm text-left" data-id="element-2629">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-2630">
                <tr data-id="element-2631">
                  <th className="px-6 py-4 font-medium" data-id="element-2632">Document Name</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2633">Deal / Show</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2634">Status</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2635">Generated</th>
                  <th className="px-6 py-4 text-right" data-id="element-2636">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-2637">
                {[{
              name: 'Contract_Beachland_Tavern.pdf',
              deal: 'Beachland Tavern (Jun 14)',
              status: 'Sent',
              date: 'Yesterday'
            }, {
              name: 'Rider_Higher_Ground.pdf',
              deal: 'Higher Ground (Jun 18)',
              status: 'Viewed',
              date: '2 days ago'
            }, {
              name: 'Contract_Empty_Bottle_Draft.pdf',
              deal: 'The Empty Bottle (Jun 12)',
              status: 'Draft',
              date: 'Today'
            }].map((doc, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-2638">
                    <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-2639">
                      <FileText className="w-4 h-4 text-textMuted" data-id="element-2640" /> {doc.name}
                    </td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2641">{doc.deal}</td>
                    <td className="px-6 py-4" data-id="element-2642">
                      <span className={`px-2 py-1 text-xs rounded font-medium ${doc.status === 'Sent' ? 'bg-blue-500/10 text-blue-500' : doc.status === 'Viewed' ? 'bg-purple-500/10 text-purple-500' : 'bg-surface border border-border text-textMuted'}`} data-id="element-2643">
                        {doc.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2644">{doc.date}</td>
                    <td className="px-6 py-4 text-right" data-id="element-2645">
                      <button className="p-1 text-textMuted hover:text-textMain transition-colors rounded hover:bg-background" data-id="element-2646">
                        <MoreHorizontal className="w-4 h-4" data-id="element-2647" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}

        {activeTab === 'Signed Docs' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-2648">
            <table className="w-full text-sm text-left" data-id="element-2649">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-2650">
                <tr data-id="element-2651">
                  <th className="px-6 py-4 font-medium" data-id="element-2652">Document Name</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2653">Deal / Show</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2654">Signatories</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2655">Date Signed</th>
                  <th className="px-6 py-4 text-right" data-id="element-2656">Download</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-2657">
                {[{
              name: 'Contract_Antones_Signed.pdf',
              deal: "Antone's (Mar 15)",
              sigs: '2/2',
              date: 'Feb 10, 2026'
            }, {
              name: 'Contract_Continental_Signed.pdf',
              deal: 'Continental Club (Mar 18)',
              sigs: '2/2',
              date: 'Feb 12, 2026'
            }, {
              name: 'Contract_WhiteOak_Signed.pdf',
              deal: 'White Oak (Mar 20)',
              sigs: '2/2',
              date: 'Feb 15, 2026'
            }].map((doc, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-2658">
                    <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-2659">
                      <FileSignature className="w-4 h-4 text-green-500" data-id="element-2660" />{' '}
                      {doc.name}
                    </td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2661">{doc.deal}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2662">{doc.sigs}</td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2663">{doc.date}</td>
                    <td className="px-6 py-4 text-right" data-id="element-2664">
                      <button className="p-2 text-textMuted hover:text-primary transition-colors bg-background rounded-md border border-border" data-id="element-2665">
                        <Download className="w-4 h-4" data-id="element-2666" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}

        {activeTab === 'Clause Library' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-2667">
            <table className="w-full text-sm text-left" data-id="element-2668">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-2669">
                <tr data-id="element-2670">
                  <th className="px-6 py-4 font-medium" data-id="element-2671">Clause Name</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2672">Preview</th>
                  <th className="px-6 py-4 font-medium" data-id="element-2673">Category</th>
                  <th className="px-6 py-4 text-right" data-id="element-2674">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-2675">
                {[{
              name: 'Force Majeure (Standard)',
              preview: 'In the event that performance is prevented by...',
              cat: 'Legal'
            }, {
              name: 'Radius Clause (Standard)',
              preview: 'Artist agrees not to perform within 60 miles...',
              cat: 'Routing'
            }, {
              name: 'Radius Clause (Festival)',
              preview: 'Artist agrees not to perform within 120 miles...',
              cat: 'Routing'
            }, {
              name: 'Merch Split (Standard)',
              preview: 'Venue retains 0% of soft goods, 0% of hard goods...',
              cat: 'Finance'
            }].map((clause, i) => <tr key={i} className="hover:bg-surfaceHover transition-colors" data-id="element-2676">
                    <td className="px-6 py-4 font-medium" data-id="element-2677">{clause.name}</td>
                    <td className="px-6 py-4 text-textMuted truncate max-w-xs" data-id="element-2678">
                      {clause.preview}
                    </td>
                    <td className="px-6 py-4 text-textMuted" data-id="element-2679">
                      <span className="px-2 py-1 bg-background border border-border rounded text-xs" data-id="element-2680">
                        {clause.cat}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-2681">
                      <button className="p-1.5 text-textMuted hover:text-textMain transition-colors rounded hover:bg-background" data-id="element-2682">
                        <Edit2 className="w-4 h-4" data-id="element-2683" />
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </motion.div>;
}